import { TasksState } from './reducer';
import { AppState } from '@/app/State/AppState';
import { createSelector } from '@ngrx/store';

const tasksState = (state: AppState) => state.tasks;

export const selectTasksIsFetching = createSelector(
  tasksState,
  (state: TasksState) => state.fetching
);

export const selectTasksFilter = createSelector(
  tasksState,
  (state: TasksState) => state.filter
);

export const selectTasksActiveStatus = createSelector(
  tasksState,
  (state: TasksState) => state.activeTasksStatus
);

export const selectTasksState = createSelector(
  tasksState,
  (state: TasksState) => state
);

// Home page selectors
export const selectMyOpenTasksForHome = createSelector(
  tasksState,
  (state: TasksState) => state.myOpenTasksForHome
);

export const selectMyOpenTasksForHomeFetching = createSelector(
  tasksState,
  (state: TasksState) => state.myOpenTasksForHomeFetching
);

export const selectMyOpenTasksForHomeLastUpdated = createSelector(
  tasksState,
  (state: TasksState) => state.myOpenTasksForHomeLastUpdated
);

export const selectMyOpenTasksForHomeError = createSelector(
  tasksState,
  (state: TasksState) => state.myOpenTasksForHomeError
);

export const selectMyOpenTasksForHomeCount = createSelector(
  selectMyOpenTasksForHome,
  (tasks) => tasks.length
);

// Cache management selectors
export const selectCacheInvalidated = createSelector(
  tasksState,
  (state: TasksState) => state.cacheInvalidated
);

// Combined selector for home page loading state
export const selectHomePageTasksState = createSelector(
  selectMyOpenTasksForHome,
  selectMyOpenTasksForHomeFetching,
  selectMyOpenTasksForHomeLastUpdated,
  selectMyOpenTasksForHomeError,
  selectMyOpenTasksForHomeCount,
  (tasks, fetching, lastUpdated, error, count) => ({
    tasks,
    fetching,
    lastUpdated,
    error,
    count,
    isEmpty: count === 0,
    hasData: count > 0
  })
);
